import React from 'react';
import { Modal } from 'react-bootstrap';
import { XCircle, AlertTriangle, Info, CheckCircle } from 'lucide-react';

const ErrorModal = ({ 
  show, 
  onHide, 
  title = "Error", 
  message = "", 
  type = "error", // error, warning, info, success
  primaryButtonText = "OK",
  secondaryButtonText = null,
  onPrimaryClick = null,
  onSecondaryClick = null 
}) => {
  const getIcon = () => {
    switch (type) {
      case 'error':
        return <XCircle className="w-12 h-12 text-red-500" />;
      case 'warning':
        return <AlertTriangle className="w-12 h-12 text-yellow-500" />;
      case 'info':
        return <Info className="w-12 h-12 text-blue-500" />;
      case 'success':
        return <CheckCircle className="w-12 h-12 text-green-500" />;
      default:
        return <XCircle className="w-12 h-12 text-red-500" />;
    }
  };

  const getBorderColor = () => {
    switch (type) {
      case 'error':
        return 'border-red-500';
      case 'warning':
        return 'border-yellow-500';
      case 'info':
        return 'border-blue-500';
      case 'success':
        return 'border-green-500';
      default:
        return 'border-red-500';
    }
  };

  const handlePrimaryClick = () => {
    if (onPrimaryClick) {
      onPrimaryClick();
    } else {
      onHide();
    }
  };

  const handleSecondaryClick = () => {
    if (onSecondaryClick) {
      onSecondaryClick();
    } else {
      onHide();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <div className={`border-t-4 ${getBorderColor()}`}>
        <Modal.Body className="p-6">
          <div className="flex flex-col items-center text-center">
            <div className="mb-4">
              {getIcon()}
            </div>
            
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              {title}
            </h3>
            
            <p className="text-gray-600 text-sm mb-6 max-w-sm">
              {message}
            </p>
            
            <div className="flex gap-3 w-full justify-center">
              {secondaryButtonText && (
                <button
                  onClick={handleSecondaryClick}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
                >
                  {secondaryButtonText}
                </button>
              )}
              
              <button
                onClick={handlePrimaryClick}
                className={`px-6 py-2 text-sm font-medium text-white rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors duration-200 ${
                  type === 'error' 
                    ? 'bg-red-600 hover:bg-red-700 focus:ring-red-500'
                    : type === 'warning'
                    ? 'bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500'
                    : type === 'success'
                    ? 'bg-green-600 hover:bg-green-700 focus:ring-green-500'
                    : 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500'
                }`}
              >
                {primaryButtonText}
              </button>
            </div>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default ErrorModal;